/** Service hours id for trial / fallback service hours. */
export const DEFAULT_SERVICE_HOURS_ID = "default";

const notSet = "Service hours are not set";
const weekdaysMondayFirst = [
    ["monday", "Mon"],
    ["tuesday", "Tue"],
    ["wednesday", "Wed"],
    ["thursday", "Thu"],
    ["friday", "Fri"],
    ["saturday", "Sat"],
    ["sunday", "Sun"],
] as const;

export type ServiceHoursExampleSlot = {
    enabled: boolean;
    hours: {
        opening: { hour: number; minute: number };
        closing: { hour: number; minute: number };
    };
};

export type ServiceHoursExampleWeek = Record<
    (typeof weekdaysMondayFirst)[number][0],
    ServiceHoursExampleSlot
>;

export function toExampleServiceHoursText(week: ServiceHoursExampleWeek): string {
    const result: string[] = [];
    let firstDay: string | undefined;
    let lastDay = "";
    let currentHoursText = "";

    for (const [weekday, abbreviation] of weekdaysMondayFirst) {
        const slot = week[weekday];
        const hoursText = slotToHoursText(slot);

        if (slot.enabled) {
            if (!firstDay) {
                firstDay = abbreviation;
                currentHoursText = hoursText;
            }
            if (currentHoursText !== hoursText) {
                result.push(toBlockText(firstDay, lastDay, currentHoursText));
                firstDay = abbreviation;
                currentHoursText = hoursText;
            }
            lastDay = abbreviation;
        } else if (firstDay) {
            result.push(toBlockText(firstDay, lastDay, currentHoursText));
            firstDay = undefined;
            lastDay = "";
            currentHoursText = "";
        }
    }

    if (firstDay) {
        result.push(toBlockText(firstDay, lastDay, currentHoursText));
    }

    return result.length > 0 ? result.join(", ") : notSet;
}

function slotToHoursText(slot: ServiceHoursExampleSlot): string {
    const { opening, closing } = slot.hours;
    return `${opening.hour}:${zeroPad(opening.minute)} - ${closing.hour}:${zeroPad(closing.minute)}`;
}

function toBlockText(firstDay: string, lastDay: string, hoursText: string): string {
    const prefix = firstDay === lastDay ? firstDay : `${firstDay} - ${lastDay}`;
    return `${prefix}: ${hoursText}`;
}

function zeroPad(value: number): string {
    return String(value).padStart(2, "0");
}
